import type { IStaticUrls } from "@/shared/common/types";
import { useAppSelector, useTranslationExists } from "@/shared/hooks";
import { Link } from "@ab.uitools/ui-library/components/Link";

interface Props {
  keys: string[];
}

export const InfoLinks = (
  { keys }: Props) => {
  const { t, lang } = useTranslationExists();
  const staticUrls = useAppSelector((state) => state.staticUrls.data);

  return (
    <div className="mb-12 flexbox flex-direction--column">
      {keys?.map?.((key) =>
        <Link
          className="mb-10 flexbox cursor-pointer"
          key={key}
          target="_blank"
          url={(staticUrls?.[key as keyof IStaticUrls])?.[lang]}>
          {t(`information.${key}`)}
        </Link>
      )}
    </div>
  );
};
